<template>
  <component
    v-if="formComponent && !loadingFormdata"
    :is="formComponent"
    :form="formData"
    @mounted="handleFormMounted"
    ref="form$"
    :key="componentKey"
  />
</template>

<script>
import axios from 'axios'

import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    form: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      endpoint: `${process.env.VUE_APP_API_URL}/forms/{form}`,
      formComponent: 'form-component',
      formData: {},
      form$: {},
      componentKey: 0,
      loadingFormdata: true
    }
  },
  created() {
    if (this.form !== '') {
      this.setSelectedFormId(this.form)
    }
    const formSchema = this.getFormSchemas[this.form]
    // if (formSchema === undefined) {
    axios
      .get(this.endpoint.replace('{form}', this.form))
      .then(({ data }) => {
        this.formData = data.data
        this.updateForm()
      })
      .catch(() => {
        this.formData = formSchema
        this.updateForm()
      })
    // } else {
    //   this.formData = formSchema
    //   if (this.getFormData[this.getSelectedFormId]) {
    //     this.formData.data = this.getFormData[this.getSelectedFormId]
    //   }
    //   this.loadingFormdata = false
    //   this.forceRerender()
    //   this.setMeta()
    // }
  },
  methods: {
    ...mapActions({
      updateFormSchemas: 'calls/updateFormSchemas',
      setSelectedFormId: 'calls/setSelectedFormId'
    }),
    handleFormMounted() {},
    forceRerender() {
      this.componentKey += 1
    },
    setMeta() {
      let model_field =
        this.formData.schema.model_type.default == 'App\\Models\\CallAssignment'
          ? 'call_assignment_id'
          : 'call_id' //this will likely need extending
      this.formData.schema.model_id
        ? (this.formData.schema.model_id.default = this.activeCall[model_field])
        : null
      this.formData.schema.user_id
        ? (this.formData.schema.user_id.default = this.user.id)
        : null
      this.updateFormSchemas({
        form: this.form,
        value: this.formData
      })
    },
    updateForm() {
      if (this.getFormData[this.getSelectedFormId]) {
        this.formData.data = this.getFormData[this.getSelectedFormId]
      }
      this.setMeta()
      this.forceRerender()
      this.loadingFormdata = false
    }
  },
  computed: {
    ...mapGetters({
      activeCall: 'calls/getActiveCall',
      user: 'root/user',
      getFormSchemas: 'calls/getFormSchemas',
      getFormData: 'calls/getFormData',
      getSelectedFormId: 'calls/getSelectedFormId'
    })
  }
}
</script>
